import { SEL_DAY_PERC_WIDTH } from '../constants/dayViewStyleConstants'

export const getDayCardWidth = ({ isEditing, isEditingSameWk, weekWidth }) => {
  let cardW

  //if nothing is selected, all widths should be week container width / 7
  if (weekWidth < 1024) {
    cardW = weekWidth
  } else if (isEditing) {
    //is selected
    cardW = weekWidth * SEL_DAY_PERC_WIDTH
  } else if (isEditingSameWk) {
    //not selected but same week
    cardW = (weekWidth * (1 - SEL_DAY_PERC_WIDTH) * 1) / 6
  } else if (!isEditingSameWk) {
    cardW = weekWidth / 7
  } else {
    //default to 1/7
    cardW = weekWidth / 7
  }

  return cardW
}
